'use strict';

var _ = require('lodash');
var SystemStatusFlightSentAndFlightReoptTransformerFactory = function SystemStatusFlightSentAndFlightReoptTransformerFactory($rootScope, DataTransformer, momentService, UserProcessingTransformationService) {
  var NOT_VISIBLE_STATUSES = ['NEW-FLIGHT-DATE-OPTIMIZATION-REQUIRED'];
  function SystemStatusFlightSentAndFlightReoptTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['status-service-sent-mode', 'status-flight-sent-mode', 'system-status-flight-reopt-mode'];
    this.priority = 1;
  }
  SystemStatusFlightSentAndFlightReoptTransformer.prototype = Object.create(DataTransformer.prototype);
  SystemStatusFlightSentAndFlightReoptTransformer.constructor = SystemStatusFlightSentAndFlightReoptTransformer;
  SystemStatusFlightSentAndFlightReoptTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType.indexOf(sourceType) > -1;
  };
  SystemStatusFlightSentAndFlightReoptTransformer.prototype.isCacheable = function () {
    return false;
  };
  SystemStatusFlightSentAndFlightReoptTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  SystemStatusFlightSentAndFlightReoptTransformer.prototype.transform = function (data) {
    var length = data && data.domain && data.domain.length || 0;
    for (var i = 0; i < length; i++) {
      var entry = data.domain[i];
      entry.departureDate = momentService.of(entry.departureDate, momentService.FIELD.DEPARTURE_DATE);
      entry.creationDate = momentService.of(entry.creationDate, momentService.FIELD.CREATED_DATE);
      entry.completionDate = momentService.of(entry.completionDate, momentService.FIELD.COMPLETED_DATE);
      if (entry.owner) {
        entry.owner = UserProcessingTransformationService.getUserDisplayName(entry.owner);
      }
      if (entry.userName) {
        entry.userName = convertUserName(entry.userName);
      }
    }
    return filterNotVisibleStatuses(data.domain);
  };
  function convertUserName(userNameFromDB) {
    var userNames = _.split(userNameFromDB, ', ');
    return _.chain(userNames).map(function (userName) {
      return UserProcessingTransformationService.getUserDisplayName(userName);
    }).join(', ').value();
  }
  function filterNotVisibleStatuses(data) {
    return _.filter(data, function (d) {
      return NOT_VISIBLE_STATUSES.indexOf(d.status) === -1;
    });
  }
  return SystemStatusFlightSentAndFlightReoptTransformer;
};
SystemStatusFlightSentAndFlightReoptTransformerFactory.$inject = ['$rootScope', 'DataTransformerFactory', 'MomentService', 'UserProcessingTransformationService'];
module.exports = SystemStatusFlightSentAndFlightReoptTransformerFactory;